// extracted by mini-css-extract-plugin
module.exports = {"directoryCardContainer":"DirectoryCardArea_directoryCardContainer__2E8w3","fillColor":"DirectoryCardArea_fillColor__1zTAu"};